import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const IndexView = r => require.ensure([], () => r(require('../views/IndexView')), 'IndexView');
const ForgotView = r => require.ensure([], () => r(require('../views/ForgotView')), 'ForgotView');
const ForgotResetView = r => require.ensure([], () => r(require('../views/ForgotResetView')), 'ForgotResetView');
const UserResetPassword = r => require.ensure([], () => r(require('../views/UserResetPassword')), 'UserResetPassword');
const NotFoundView = r => require.ensure([], () => r(require('../views/NotFoundView')), 'NotFoundView');
const AccountsView = r => require.ensure([], () => r(require('../views/AccountsView')), 'AccountsView');
const DocumentsView = r => require.ensure([], () => r(require('../views/DocumentsView')), 'DocumentsView');
const DocView = r => require.ensure([], () => r(require('../views/DocumentView.vue')), 'DocView');


const UserPassword = r => require.ensure([], () => r(require('../components/accounts/UserPassword.vue')), 'UserPassword');
const UserInfo = r => require.ensure([], () => r(require('../components/accounts/UserInfo.vue')), 'UserInfo');
const UserEmail = r => require.ensure([], () => r(require('../components/accounts/UserEmail.vue')), 'UserEmail');

const MyApps = r => require.ensure([], () => r(require('../components/application/MyApps.vue')), 'MyApps');
const UploadApps = r => require.ensure([], () => r(require('../components/application/UploadApps.vue')), 'UploadApps');

const keyApplication = r => require.ensure([], () => r(require('../components/key/keyApplication.vue')), 'keyApplication');
const myKeys = r => require.ensure([], () => r(require('../components/key/myKeys.vue')), 'myKeys');

const messageApplication = r => require.ensure([], () => r(require('../components/message/msgApplication.vue')), 'messageApplication');
const myMessages = r => require.ensure([], () => r(require('../components/message/myMessages.vue')), 'myMessages');
const updateMessage = r => require.ensure([], () => r(require('../components/message/updateMessage.vue')), 'updateMessage');

const axq_contract = r => require.ensure([], () => r(require('../components/contract/axq_contract.vue')), 'axq_contract');

const routes = [
    { path: '/', component: IndexView },
  	{ path: '/forgot', component: ForgotView },
  	{ path: '/forgot-reset', component: ForgotResetView },
    { path: '/user-reset-password', component: UserResetPassword },
    { path: '/doc', component: DocView },
    { path: '/axq_contract', component: axq_contract },
    {
      path: '/accounts',
      component: AccountsView,
      children: [
        {
          path: 'user-password',
          components: {
            accountsView: UserPassword
          }
        },
        {
          name:"user-info",
          path: 'user-info',
          components: {
            accountsView: UserInfo
          }
        },
        {
          path: 'user-email',
          components: {
            accountsView: UserEmail
          }
        }
      ]
    },
    {
      path: '/application',
      component: AccountsView,
      children: [
        {
        	name:'myApps',
          path: 'my-apps',
          components: {
            accountsView: MyApps
          }
        },
        {
        	name:'uploadApps',
          path: 'upload-apps',
          components: {
            accountsView: UploadApps
          }
        }
      ]
    },
    {
      path: '/key',
      component: AccountsView,
      children: [
        {
        	name:'keyApplication',
          path: 'keyApplication',
          components: {
            accountsView: keyApplication
          }
        },
        {
        	name:'myKeys',
          path: 'myKeys',
          components: {
            accountsView: myKeys
          }
        }
      ]
    },
    {
      path: '/message',
      component: AccountsView,
      children: [
        {
        	name:'messageApplication',
          path: 'messageApplication',
          components: {
            accountsView: messageApplication
          }
        },
        {
        	name:'myMessages',
          path: 'myMessages',
          components: {
            accountsView: myMessages
          }
        },
        {
        	name:'updateMessage',
          path: 'updateMessage/:idNotify',
          components: {
            accountsView: updateMessage
          }
        }
      ]
    },
    { path: '/*', component: NotFoundView }
  ]

export default new Router({
	mode: 'history',
	routes,
	strict: process.env.NODE_ENV !== 'production',
})



// WEBPACK FOOTER //
// ./src/router/index.js